<template>
    <div class="about">
        <!-- Hero banner -->
        <section class="about-hero">
            <img class="about-hero__bg"
                src="https://qiniu.shunmingelectronic.com/guanwang/product/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC.png"
                alt="关于我们" />
            <div class="about-hero__overlay"></div>
            <div class="km-container about-hero__content">
                <span class="km-eyebrow">ABOUT US</span>
                <h1 class="km-h1">关于我们</h1>
            </div>
        </section>

        <!-- Intro 1 -->
        <section class="km-section">
            <div class="km-container">
                <div class="section-head">
                    <span class="km-eyebrow">关于舜铭</span>
                    <h2 class="km-h2">以创新驱动，重塑产业价值</h2>
                </div>
                <div class="about-split">
                    <div class="about-split__media km-card">
                        <img src="https://qiniu.shunmingelectronic.com/guanwang/product/huiyi.jpg" alt="舜铭团队" />
                    </div>
                    <div class="about-split__text">
                        <p>
                            河南舜铭电子信息科技有限公司是一家新成立的科技型企业，位于河南省洛阳市高新区。我们的团队专注于电子信息和物联网领域的研发，致力于为客户提供全面的智能化与信息化解决方案，包括物联网平台、仪器仪表PCB、智能传感器、物联网设备、人工智能和边缘计算等服务。
                        </p>
                        <p>
                            我们以精益求精、合作共赢为理念，联合传统行业的同仁，通过脚踏实地的研发和不断创新实现优势互补，将数字化和信息化的理念整合到传统行业中，共同提升产品竞争力，达到 1+1 大于 2 的效果。
                        </p>
                    </div>
                </div>

                <div class="about-split about-split--reverse">
                    <div class="about-split__text">
                        <p>
                            此外，我们还将先进的 4G 技术融入我们的仪器，实现无缝数据传输到物联网平台。这可以实现实时监控和管理，确保我们的客户从增强的连接性和运营效率中受益。
                        </p>
                    </div>
                    <div class="about-split__media km-card">
                        <img src="https://qiniu.shunmingelectronic.com/guanwang/platform.jpg" alt="物联网平台" />
                    </div>
                </div>
            </div>
        </section>

        <!-- Why choose us -->
        <section class="km-section about-why">
            <div class="km-container">
                <div class="section-head">
                    <span class="km-eyebrow">WHY CHOOSE US</span>
                    <h2 class="km-h2">为什么选择我们</h2>
                </div>
                <div class="about-why__grid">
                    <article v-for="(item, i) in reasons" :key="i" class="km-card about-why__card">
                        <div class="about-why__icon"><img :src="item.icon" :alt="item.title" /></div>
                        <div class="about-why__body">
                            <h3 class="km-h3">{{ item.title }}</h3>
                            <p>{{ item.desc }}</p>
                        </div>
                    </article>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'AboutView',
    data() {
        return {
            reasons: [
                { icon: require('../assets/chuanx.png'), title: '创新', desc: '我们不断创新，将 4G 技术融入仪器中，实现与物联网平台的无缝连接并提供智能解决方案。' },
                { icon: require('../assets/zhuanye.png'), title: '专业', desc: '我们在流量计的研究和生产方面拥有多年经验，可提供高质量的产品和解决方案。' },
                { icon: require('../assets/fuwu.png'), title: '优质服务', desc: '我们不仅提供产品，还提供全面的技术支持和售后服务，确保为客户提供无忧的体验。' },
                { icon: require('../assets/kehu.png'), title: '以客户为中心', desc: '我们优先考虑客户需求，提供定制解决方案以帮助实现更高的运营效率。' }
            ]
        }
    }
}
</script>

<style scoped>
.about {
    background: var(--bg);
}

/* Hero */
.about-hero {
    position: relative;
    min-height: 460px;
    display: flex;
    align-items: center;
    overflow: hidden;
}

.about-hero__bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.about-hero__overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0.7) 60%, var(--bg) 100%);
}

.about-hero__content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    padding-top: 80px;
}

.about-hero__content .km-h1 {
    color: #fff;
}

.about-hero__content .km-eyebrow {
    color: #fff;
    border-color: rgba(255, 255, 255, 0.4);
    background: rgba(255, 255, 255, 0.10);
}

/* Section head */
.section-head {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 18px;
    margin-bottom: 60px;
}

/* Split rows */
.about-split {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 48px;
    align-items: center;
    margin-bottom: 40px;
}

.about-split__media {
    overflow: hidden;
    padding: 0;
}

.about-split__media img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
}

.about-split__text {
    text-align: left;
}

.about-split__text p {
    color: var(--text-soft);
    font-size: 17px;
    line-height: 1.85;
    margin: 0 0 20px;
}

.about-split__text p:last-child {
    margin-bottom: 0;
}

/* Why */
.about-why__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
}

.about-why__card {
    display: flex;
    align-items: center;
    gap: 26px;
    padding: 34px 32px;
    text-align: left;
}

.about-why__icon {
    flex-shrink: 0;
    width: 84px;
    height: 84px;
    border-radius: 18px;
    background: var(--accent-soft);
    border: 1px solid var(--border);
    display: flex;
    align-items: center;
    justify-content: center;
}

.about-why__icon img {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.about-why__body h3 {
    margin-bottom: 10px;
}

.about-why__body p {
    color: var(--text-soft);
    font-size: 15px;
    line-height: 1.7;
    margin: 0;
}

@media (max-width: 900px) {

    .about-split,
    .about-split--reverse,
    .about-why__grid {
        grid-template-columns: 1fr;
        gap: 28px;
    }

    .about-split--reverse .about-split__media {
        order: -1;
    }
}
</style>
